module.exports = __webpack_public_path__ + "assets/2b505011c6314e5dd50bc7628051a924.png";